import {cssTheme} from '../theme'
import {css} from '../theme/css'

export const fullWidth = css`
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
`

// Хексы - cssTheme.default.day.error, на который наложили 5% и 10% черного цвета соответственно. Когда пытаюсь делать это программно - стили ломаются, делаю сейчас так чтобы закрыть до отпуска
// TODO - сделать нормально
export const error = css`
  ${cssTheme.default.day.controlMinorText.token}: ${cssTheme.default.day.textInvert};
  ${cssTheme.components.buttons.ghost.bgColor.token}: ${cssTheme.default.day.error};
  ${cssTheme.components.buttons.ghost.bgColorHovered.token}: #ed3a29;
  ${cssTheme.components.buttons.ghost.bgColorPressed.token}: #e13727
`

// тупо копирую класс для отображения загрузки из компонента кнопки
// по дефолту GWC его не экспортирует
export const loadingClassName = css`
  @keyframes loadingEffect {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }

  position: relative;
  pointer-events: none;

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    animation: loadingEffect 2s infinite;
    display: block;
    content: '';
    background: ${cssTheme.components.buttons.loadingGradient};
  }
`
